import { render, staticRenderFns } from "./GentleDetoxificationOrganicCoffeeEnema.vue?vue&type=template&id=6ae62c9b&scoped=true&"
import script from "./GentleDetoxificationOrganicCoffeeEnema.vue?vue&type=script&lang=js&"
export * from "./GentleDetoxificationOrganicCoffeeEnema.vue?vue&type=script&lang=js&"
import style0 from "./GentleDetoxificationOrganicCoffeeEnema.vue?vue&type=style&index=0&id=6ae62c9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae62c9b",
  null
  
)

export default component.exports